import { useLocation } from "react-router-dom";
import { GetHealthPlace, dadosUser } from "../../Services/Auth";
import { DominioURL } from "../../Components/Auth/isAuthenticated";

function External() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get("token");

  localStorage.setItem("token", token || "");

  GetHealthPlace(DominioURL()).then(() => {
    dadosUser().then(() => {
      // Redirecionar para home/external mantendo os parâmetros da URL
      const currentUrl = new URL(window.location.href);
      const params = currentUrl.search;
      window.location.href = `/home/external${params}`;
    });
  });

  return <div>Processando login</div>;
}

export default External;
